module.exports = __webpack_public_path__ + "static/img/14010215.4e2a5dfe.png";